export const roundTo = (value, precision = 2) => {
    const factor = 10 ** precision;
    return Math.round(parseFloat(String(value)) * factor) / factor;
};
//# sourceMappingURL=roundTo.js.map